import { createLatLangObjectFromString, getMap } from '../../_flux/helper/gmap';
import { applyPostcodeAction } from '../../_flux/actions/postcode_actions';
import MapActions from '../../_flux/actions/map_actions';
import GetParameters from '../get_parameters';
import LightboxActions from '../../_flux/actions/lightbox_actions';
import { FsfPages } from '../../_constants/fsf_pages';
import FittingStationFinderConstants from '../../_flux/constants/fitting_station_finder_constants';
import StationsActions from '../../_flux/actions/fitting_station_actions';
import { ProductsStore } from '../../_flux/stores/products_store';
import ActiveStationStore from '../../_flux/stores/active_station_store';
import FittingStationStore from '../../_flux/stores/fitting_station_store';

import { getPostcodeFromLocalStorage, getValue } from '../local_storage';
import { showAutoCompletePostcodeSelector } from '../../_flux/components/PostcodeAutocomplete';

const autoOpenFsf = () => {
    const checkExist = setInterval(() => {
        if (getMap() !== null && getValue('bust') === true) {
            const userShippingAddress = TYROOLA.initialFluxStates
                && Object.prototype.hasOwnProperty
                    .call(TYROOLA.initialFluxStates, 'userShippingAddress')
                && TYROOLA.initialFluxStates.userShippingAddress
                && TYROOLA.initialFluxStates.userShippingAddress.postcode
                && TYROOLA.initialFluxStates.userShippingAddress.latitude
                && TYROOLA.initialFluxStates.userShippingAddress.longitude ?
                TYROOLA.initialFluxStates.userShippingAddress
                :
                null;

            if (userShippingAddress === null) {
                clearInterval(checkExist);
                return;
            }
            const postcode = showAutoCompletePostcodeSelector(TYROOLA.globals.store) ? getPostcodeFromLocalStorage() : userShippingAddress.postcode;



            applyPostcodeAction(postcode);
            const newLocation = createLatLangObjectFromString(userShippingAddress.latitude, userShippingAddress.longitude);
            if (newLocation.lat() !== false && newLocation.lng() !== false) {
                MapActions.setLatLngAction(newLocation);
            } else {
                clearInterval(checkExist);
                return;
            }

            const getParameters = new GetParameters();
            if (getParameters.has('fitting') && getParameters.get('fitting') === '1') {
                LightboxActions.totalPagesChangeAction(FsfPages.WITHOUT_SUCCESS_NOTIFICATION);
                LightboxActions.goToPageAction(FittingStationFinderConstants.LIGHTBOX_PAGE_USAGE_DESCRIPTION);
                LightboxActions.openAction();
                if (getParameters.has('view')) {
                    if (getParameters.get('view') === 'list' || getParameters.get('view') === 'fdp') {
                        StationsActions.startFetchingStationsAction();
                        MapActions.updateLatLngAction(userShippingAddress.postcode)
                            .then(() => {

                                StationsActions.fetchStationsAction({
                                    postcode,
                                    latitude: parseFloat(userShippingAddress.latitude),
                                    longitude: parseFloat(userShippingAddress.longitude)
                                }, ProductsStore.getState());
                            }).then(() => {
                                getMap().setMapAddress(newLocation);

                                // by default will open to FSF LIST page
                                // in case of view === list

                                LightboxActions.goToPageAction(FittingStationFinderConstants.LIGHTBOX_PAGE_FINDER);

                                // view === fdp, then check if activeStation.id is exist in StationList
                                // if EXIST ? then view detail station
                                // if NOT ? just stay in the fsf list page
                                if (getParameters.get('view') === 'fdp') {
                                    const { activeStation } = ActiveStationStore.getState();
                                    const checkStations = setInterval(() => {
                                        if (FittingStationStore.getState().stations.length) {
                                            if (activeStation && activeStation.id) {
                                                const { stations } = FittingStationStore.getState();
                                                const foundStation = stations.find(x => x.id === activeStation.id);
                                                if (foundStation) {
                                                    StationsActions.showDetailsAction(activeStation.id);
                                                }
                                            }

                                            clearInterval(checkStations);
                                        }
                                    }, 100);
                                }
                            });
}
    }
            }

clearInterval(checkExist);
        }
    }, 100); // check every 100ms
};

export default autoOpenFsf;
